var sika = sika || {};
( function () {
    sika.shoefinder = {
        debug: false,
        isLoaded: false,
        doReset: false,
        hasProducts: false,
        isMultipleChoice: false,
        globals: {
            checkNestedStepOnPrev: false,
            hasNextButton: false,
            step: null,
            productlist: null,
            product: null,
            variant: null
        },
        options: {
            timeout: 1000
        },
        localData: window.sikaShoefinderData,
        init: function () {
            //sika.shoefinder.cache();
            if ( jQuery( '.js-sika-shoefinder' ).length === 1) {
                e4.util.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerHelpers( 'compare' );
                    sika.shoefinder.handlebars.registerHelpers();
                    e4.handlebars.registerPartials( '#js-e-handlebars-partial-shoefinder-productlist #js-e-handlebars-partial-shoefinder-navigation #js-e-handlebars-partial-shoefinder-feedback #js-e-handlebars-partial-shoefinder-product-details #js-e-handlebars-partial-shoefinder-filters' );
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-shoefinder-steps' );
                    sika.shoefinder.bindEvents();

                } );
            }
        },
        loader: {
            show: function () {
                jQuery( '.js-e-loading-overlay-shoefinder' ).addClass( 'is-loading' );
            },
            hide: function () {
                jQuery( '.js-e-loading-overlay-shoefinder' ).removeClass( 'is-loading' );
            }
        },
        cache: function () {
            if ( sessionStorage.getItem( 'sika.shoefinder.cached' ) === null ) {
                jQuery.get( e4.settings.ecom.filters.url + '?v=' + ( new Date().getTime() ), function () {
                    sessionStorage.setItem( 'sika.shoefinder.cached', true );
                } );
            }
        },
        handlebars: {
            registerHelpers: function () {
                Handlebars.registerHelper( 'renderFeedback', function ( feedbackStep, feedbackStr, feedbackParam ) {

                    var paramLabel = sika.shoefinder.store.feedback.load( feedbackParam );

                    if ( paramLabel !== undefined && paramLabel !== false ) {
                        feedbackStr = feedbackStr.replace( /\{{(.+?)\}}/g, '<a class="sika-shoefinder-feedback-item js-sika-shoefinder-feedback-item" data-index="' + feedbackStep + '">' + paramLabel + '</a>' );
                        return '<span>' + feedbackStr + '</span>';
                    }
                } );
                Handlebars.registerHelper( 'renderExtrasFeedback', function () {
                    var returnString = '<ul class="material-icons-ul sika-shoefinder-feedback-extra-items small">';
                    jQuery( '.js-sika-shoefinder-post-values[data-index="5"]' ).each( function ( index ) {
                        if ( jQuery( this ).val() !== '' ) {
                            returnString += '<li><i class="material-icons">done</i><a class="sika-shoefinder-feedback-item js-sika-shoefinder-feedback-item" data-index="5">' + jQuery( this ).data( 'label' ) + '</a></li>';
                        }
                    } );
                    returnString += '</ul>';
                    return returnString;
                } );
            }
        },
        bindEvents: function () {
            jQuery( '.js-sika-shoefinder' ).on( 'click', 'input[type="radio"].js-sika-shoefinder-question', function () {
                var currentStep = jQuery( this ).parents( '.js-sika-shoefinder-step' ),
                        inputName = jQuery( this ).data( 'name' );
                sika.shoefinder.isMultipleChoice = false;
                sika.shoefinder.store.feedback.save( inputName, jQuery( this ).data( 'label' ) );
                jQuery( '.js-sika-shoefinder-form' ).find( 'input[name="' + inputName + '"]' ).val( jQuery( this ).val() );
                if ( jQuery( this ).is( '.is-sticky-image' ) === true ) {
                    sessionStorage.setItem( 'sika.shoefinder.stickImage', jQuery( this ).data( 'next-step-background' ) );
                }
                if ( sika.shoefinder.globals.hasNextButton === false ) {
                    if ( jQuery( this ).is( '.js-sika-shoefinder-question-nested' ) === true && jQuery( this ).parents( '.js-sika-shoefinder-step-nested' ).next().is( '.js-sika-shoefinder-step-nested' ) === true && jQuery( this ).parents( '.js-sika-shoefinder-step-nested' ).next().find( '.js-sika-shoefinder-question-nested' ).is( ':checked' ) === false ) {
                        jQuery( this ).parents( '.js-sika-shoefinder-step-nested' ).next().show();
                    }
                    else {
                        sika.shoefinder.steps.navigate( currentStep.data( 'index' ), true, false );
                    }
                }
            } ).on( 'click', 'input[type="checkbox"].js-sika-shoefinder-question', function () {
                var inputName = jQuery( this ).data( 'name' );
                sika.shoefinder.isMultipleChoice = true;
                sika.shoefinder.store.feedback.save( inputName, jQuery( this ).data( 'label' ) );
                if ( jQuery( this ).is( ':checked' ) === true ) {
                    jQuery( '.js-sika-shoefinder-form' ).find( 'input[name="' + inputName + '"]' ).val( jQuery( this ).val() );
                }
                else {
                    jQuery( '.js-sika-shoefinder-form' ).find( 'input[name="' + inputName + '"]' ).val( '' );
                }
                if ( jQuery( this ).is( '.is-sticky-image' ) === true ) {
                    sessionStorage.setItem( 'sika.shoefinder.stickImage', jQuery( this ).data( 'next-step-background' ) );
                }
                sika.shoefinder.productList.update();
            } ).on( 'click', '.js-sika-shoefinder-navigation-item.visited a, a.js-sika-shoefinder-feedback-item', function () {
                sika.shoefinder.steps.navigate( jQuery( this ).data( 'index' ), false, false, true );
            } ).on( 'click', '.js-sika-shoefinder-start', function ( event ) {
                event.preventDefault();
                sika.shoefinder.steps.navigate( jQuery( this ).data( 'index' ), true, false );
            } ).on( 'click', '.js-sika-shoefinder-nested-next-button', function ( event ) {
                event.preventDefault();
                var currentStep = jQuery( this ).parents( '.js-sika-shoefinder-step' );
                sika.shoefinder.steps.navigate( currentStep.data( 'index' ), true, false );
            } ).on( 'click', '.js-sika-shoefinder-next-step-is-productlist', function () {
                dataLayer.push( {
                    'event': 'ShoeFinderResult'
                } );
            } ).on( 'change', '.js-sika-shoefinder-productlist-facet-option-input', function () {
                jQuery('.js-e-loading-overlay-shoefinder-productlist').addClass('is-loading');
                sika.shoefinder.productList.update();
            } );
            jQuery( document ).on( 'click', '.js-sika-shoefinder-edit', function ( event ) {
                event.preventDefault();
                jQuery( '.js-sika-shoefinder-alert-modal' ).modal( 'hide' );
                sika.shoefinder.steps.navigate( e4.util.hash.get( 'question' ), false, true );
            } );
            jQuery( document ).on( 'click', '.js-clear-current-step-stay', function () {
                sika.shoefinder.steps.clear( e4.util.hash.get( 'question' ) );
                sika.shoefinder.steps.navigate( e4.util.hash.get( 'question' ), false, false, true );
            } );

            jQuery( document ).on( 'click', '.js-sika-shoefinder-no-products-edit', function ( event ) {
                event.preventDefault();
                var curStep = parseInt( e4.util.hash.get( 'question' ) ) - 1;
                sika.shoefinder.steps.clear( curStep );
                jQuery( '.js-sika-shoefinder-alert-modal' ).modal( 'hide' );
                sika.shoefinder.steps.navigate( curStep, false, false, false );
            } );

            jQuery( document ).on( 'click', '.js-sika-shoefinder-clear-all', function ( event ) {
                event.preventDefault();
                sika.shoefinder.data.reset( true );
            } );

            jQuery( '.js-sika-shoefinder-productlist-modal' ).on( 'show.bs.modal', function () {
                e4.util.hash.set( 'productlist', 'true' );
            } ).on( 'hide.bs.modal', function () {
                e4.util.hash.remove( 'productlist' );
                e4.util.hash.remove( 'product' );
            } );

            jQuery( window ).on( 'hashchange load', function () {
                var hashStep = e4.util.hash.get( 'question' ),
                        hashProductlist = e4.util.hash.get( 'productlist' ),
                        hashProduct = e4.util.hash.get( 'product' ),
                        hashMyListAction = e4.util.hash.get( 'mylist' ),
                        showLoading = true;
                if ( hashStep === sika.shoefinder.globals.step ) {
                    showLoading = false;
                }
                /*
                if ( parseInt(hashStep) === 1 && sika.shoefinder.doReset === true) {
                    sika.shoefinder.data.reset( false );
                } else if(parseInt(hashStep) > 1) {
                    sika.shoefinder.doReset = true;
                }
                */
                if ( hashStep !== undefined ) {
                    history.replaceState( {
                        step: hashStep
                    }, null, location.pathname + location.hash );
                    sika.shoefinder.data.post( hashStep, showLoading );
                }
                else {
                    sika.shoefinder.data.reset( false );
                    sika.shoefinder.data.build.init( null, 0 );
                }
                if ( hashProductlist === 'true' ) {
                    jQuery( '.e-content' ).css( 'overflow', 'auto' );

                }
                else {
                    jQuery( '.e-content' ).css( 'overflow', 'hidden' );
                }

                if ( hashProduct !== undefined ) {
                    sika.shoefinder.productDetails.get( hashProduct );
                }
                if ( hashMyListAction !== undefined ) {
                    var thankYoyText = '';
                    if ( hashMyListAction === 'download' ) {
                        thankYoyText = sika.shoefinder.localData.translations.downloadThankYoy;
                    }
                    else if ( hashMyListAction === 'mailto' ) {
                        thankYoyText = sika.shoefinder.localData.translations.mailThankYoy;
                    }
                    sika.favorites.success( thankYoyText );
                }
                sika.shoefinder.globals.step = hashStep;
                sika.shoefinder.globals.productlist = hashProductlist;
                sika.shoefinder.globals.product = hashProduct;
            } ).on( 'popstate', function () {
                if ( history.state ) {
                    sika.shoefinder.steps.navigate( history.state.step, false, false );
                }
            } );
            if ( e4.util.hash.get( 'question' ) === undefined ) {
                jQuery( window ).trigger( 'hashchange' );
            }
            else {
                if ( sessionStorage.getItem( 'sika.shoefinder.facets' ) !== null ) {
                    sika.shoefinder.store.facets.load();
                }

                sika.shoefinder.steps.navigate( e4.util.hash.get( 'question' ), false, false );

            }
            sika.shoefinder.productList.bindEvents();
            sika.shoefinder.productDetails.bindEvents();
        },
        steps: {
            displayer: function (  ) {
                //console.log(sika.shoefinder.isMultipleChoice);
                if (sika.shoefinder.isMultipleChoice === true){
                    jQuery( '[data-hide-if="false"]' ).hide();
                    jQuery( '[data-show-if="true"]' ).show();
                } else{
                    jQuery( '[data-hide-if="false"]' ).show();
                    jQuery( '[data-show-if="true"]' ).hide();
                }

            },
            clear: function ( step ) {
                if ( step !== undefined ) {
                    var postValue = jQuery( '.js-sika-shoefinder-post-values[data-index="' + step + '"]' );
                    sika.shoefinder.store.remove( postValue.val() );
                    postValue.val( '' );
                    jQuery( '.js-sika-shoefinder-step-control' ).find( 'input' ).each( function () {
                        jQuery( this ).prop( 'checked', false );
                    } );
                }
                else {
                    jQuery( '.js-sika-shoefinder-post-values' ).each( function () {
                        jQuery( this ).val( '' );
                    } );
                    sika.shoefinder.store.clear();
                }
            },
            test: function ( step ) {
                var prevStepIndex = parseInt( step ) - 1,
                        hasPrevStepData = jQuery( '.js-sika-shoefinder-post-values[data-index="' + prevStepIndex + '"]' ).first().val();
                if ( sika.shoefinder.debug === true ) {
                    console.log( step, prevStepIndex, hasPrevStepData );
                }
                if ( step > 1 ) {
                    if ( hasPrevStepData !== undefined && hasPrevStepData !== '' ) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return true
                }

            },
            navigate: function ( step, next, prev, check ) {
                if ( location.search.indexOf( 'CompletedOrderId' ) > -1 ) {
                    e4.util.hash.set( 'mylist', 'mailto' );
                }
                if ( sika.shoefinder.debug === true ) {
                    console.log( 'navigate' );
                }
                if ( parseInt( step ) === 6 || ( step !== undefined && sika.shoefinder.steps.test( step ) === true ) ) {
                    var newStep = next === true ? parseInt( step ) + 1 : prev === true ? parseInt( step ) - 1 : parseInt( step );
                    if ( newStep === parseInt( e4.util.hash.get( 'question' ) ) ) {
                        jQuery( window ).trigger( 'hashchange' );
                    }
                    else {
                        if ( prev === true ) {
                            if ( sika.shoefinder.debug === true ) {
                                console.log( 'isprev' );
                            }
                            e4.util.hash.remove( 'productlist' );
                            e4.util.hash.remove( 'product' );
                            sika.shoefinder.globals.checkNestedStepOnPrev = true;
                            sika.shoefinder.steps.clear( step );
                        }
                        else {
                            if ( check !== undefined && check === true ) {
                                sika.shoefinder.globals.checkNestedStepOnPrev = true;
                            }
                            else {
                                sika.shoefinder.globals.checkNestedStepOnPrev = false;
                            }

                        }
                        e4.util.hash.set( 'question', newStep );
                    }
                }
                else {
                    jQuery( window ).trigger( 'hashchange' );
                }
            }
        },
        store: {
            remove: function ( key ) {
                var facetStore = sessionStorage.getItem( 'sika.shoefinder.facets' ) !== null ? JSON.parse( sessionStorage.getItem( 'sika.shoefinder.facets' ) ) : {},
                        feedbackStore = sessionStorage.getItem( 'sika.shoefinder.feedback' ) !== null ? JSON.parse( sessionStorage.getItem( 'sika.shoefinder.feedback' ) ) : {};
                facetStore[ key ] = '';
                delete feedbackStore[ key ];
            },
            clear: function () {
                var jLocalAllItems = Object.keys( sessionStorage );
                for ( var i = 0; i < jLocalAllItems.length; i++ ) {
                    if ( jLocalAllItems[ i ].indexOf( 'sika.shoefinder' ) > -1 ) {
                        if ( jLocalAllItems[ i ].indexOf( 'cached' ) === -1 ) {
                            sessionStorage.removeItem( jLocalAllItems[ i ] );
                        }
                    }
                }
            },
            feedback: {
                save: function ( inputName, inputLabel ) {
                    if ( sika.shoefinder.debug === true ) {
                        console.log( 'save feedback' );
                    }
                    var feedbackStore = sessionStorage.getItem( 'sika.shoefinder.feedback' );
                    if ( feedbackStore !== null ) {
                        feedbackStore = JSON.parse( sessionStorage.getItem( 'sika.shoefinder.feedback' ) );
                    }
                    else {
                        feedbackStore = {};
                    }
                    feedbackStore[ inputName ] = inputLabel;

                    sessionStorage.setItem( 'sika.shoefinder.feedback', JSON.stringify( feedbackStore ) );
                },
                load: function ( key ) {
                    var feedbackStore = sessionStorage.getItem( 'sika.shoefinder.feedback' );
                    if ( feedbackStore !== null && feedbackStore !== '' ) {
                        feedbackStore = JSON.parse( sessionStorage.getItem( 'sika.shoefinder.feedback' ) );
                        return feedbackStore[ key ];
                    }
                    else {
                        return false;
                    }

                }
            },
            facets: {
                save: function ( jFormArr ) {
                    if ( sika.shoefinder.debug === true ) {
                        console.log( 'save facet' );
                    }
                    var facetStore = {};
                    jQuery( jFormArr ).each( function () {
                        if ( facetStore[ this.name ] !== undefined ) {
                            if ( Array.isArray( facetStore[ this.name ] ) === false ) {
                                facetStore[ this.name ] = [ facetStore[ this.name ] ];
                            }
                            facetStore[ this.name ].push( this.value );
                        }
                        else {
                            facetStore[ this.name ] = this.value;
                        }

                    } );
                    sessionStorage.setItem( 'sika.shoefinder.facets', JSON.stringify( facetStore ) );
                },
                load: function () {
                    if ( sika.shoefinder.debug === true ) {
                        console.log( 'load facets' );
                    }
                    var facetStore = sessionStorage.getItem( 'sika.shoefinder.facets' ) !== null ? JSON.parse( sessionStorage.getItem( 'sika.shoefinder.facets' ) ) : {},
                            feedbackStore = sessionStorage.getItem( 'sika.shoefinder.feedback' ) !== null ? JSON.parse( sessionStorage.getItem( 'sika.shoefinder.feedback' ) ) : {};
                    jQuery.each( facetStore, function ( index, value ) {
                        jQuery( 'input[type="hidden"][name="' + index + '"]' ).val( value );
                        jQuery( 'input[data-name="' + index + '"][value="' + value + '"]' ).prop( 'checked', true );
                        if ( value === '' && feedbackStore[ index ] !== undefined ) {
                            delete feedbackStore[ index ];
                            sessionStorage.setItem( 'sika.shoefinder.feedback', JSON.stringify( feedbackStore ) )
                        }

                    } );
                }
            }
        },
        productList: {
            init: function () {
                sika.shoefinder.productList.bindEvents();
            },
            bindEvents: function () {
                jQuery( document ).on( 'click', '.js-sika-shoefinder-productlist-item-link', function ( event ) {
                    event.preventDefault();
                    var productID = jQuery( this ).data( 'product-id' );
                    e4.util.hash.set( 'product', productID );

                } );
            },
            update: function ( data ) {
                jQuery( '.js-shoefinder-productdetails-show' ).hide();
                jQuery( '.js-shoefinder-productlist-show' ).show();
                jQuery( '.js-products-productcount-container' ).css( 'visibility', 'visible' );
                if ( data !== undefined ) {
                    jQuery( '.js-sika-shoefinder-product-count' ).text( data.page.productCount );
                    if ( data.page.productCount === 0 ) {
                        sika.shoefinder.steps.displayer();
                        jQuery( '.js-sika-shoefinder-alert-modal' ).modal();
                    }
                    else {
                        jQuery( '.js-products-productcount' ).text( data.page.productCount );
                        jQuery( '.js-sika-shoefinder-productlist-step' ).html( e4.handlebars.partial.shoefinderProductlist( data ) );
                        jQuery( '.js-sika-shoefinder-productlist-filters' ).html( e4.handlebars.partial.shoefinderFilters( data ) );
                        //jQuery( '.js-sika-shoefinder-productlist' ).html( e4.handlebars.tmpl.shoefinderProductlist( data ) );
                        sika.favorites.data();
                    }

                }
                else {
                    var jForm = jQuery( '.js-sika-shoefinder-form' );
                    var jXhr = jQuery.ajax( {
                        url: e4.settings.ecom.filters.url,
                        type: 'POST',
                        data: jForm.serialize()
                    } );
                    jQuery.when( jXhr ).done( function ( data ) {
                        jQuery( '.js-sika-shoefinder-product-count' ).text( data.page.productCount );
                        //console.log(data)
                        if ( data.page.productCount === 0 ) {
                            sika.shoefinder.steps.displayer();
                            jQuery( '.js-sika-shoefinder-alert-modal' ).modal();
                        }
                        else {
                            jQuery( '.js-sika-shoefinder-productlist-step' ).html( e4.handlebars.partial.shoefinderProductlist( data ) );
                            //jQuery( '.js-sika-shoefinder-productlist' ).html( e4.handlebars.tmpl.shoefinderProductlist( data ) );
                        }

                    } )
                          .fail( function ( error ) {
                              console.error( error );
                          } );
                }
            }
        },
        productDetails: {
            variantColor: '',
            bindEvents: function () {
                jQuery( '.js-sika-shoefinder' ).on( 'click', '.js-sika-shoefinder-product-details-close', function ( event ) {
                    event.preventDefault();
                    e4.util.hash.remove( 'product' );
                } );
            },
            get: function ( prodID ) {
                var jXhr = jQuery.ajax( {
                    url: '/system/data/product',
                    type: 'GET',
                    dataType: 'JSON',
                    beforeSend: function () {
                        jQuery( '.js-sika-shoefinder-product-details-container' ).fadeOut( 'fast' );
                    },
                    data: {
                        productid: prodID.split( '-' )[ 0 ]
                    }
                } );
                jQuery.when( jXhr ).done( function ( data ) {
                    var regex = data.product.number + '_(.*?)\.jpg',
                            match = data.product.image.match( regex );
                    if ( match[ 1 ] !== prodID.split( '-' )[ 1 ] ) {
                        data.product.image = data.product.image.replace( match[ 1 ], prodID.split( '-' )[ 1 ] );
                    }
                    sika.shoefinder.productDetails.build( data );
                    //console.log(match[ 1 ],data.product.image.replace( match[ 1 ], prodID.split( '-' )[ 1 ] ))
                    //console.log(data, prodID)
                } )
                      .fail( function ( error ) {
                          console.error( error );
                      } );

            },
            build: function ( data ) {
                jQuery( '.js-sika-shoefinder-productlist-step' ).scrollTop( 0 );
                jQuery( '.js-sika-shoefinder-productlist-step' ).hide();
                jQuery( '.js-sika-shoefinder-product-details-container' ).html( e4.handlebars.partial.shoefinderProductDetails( data ) ).show();
                jQuery( '.js-shoefinder-productdetails-show' ).show();
                jQuery( '.js-shoefinder-productlist-show' ).hide();
                jQuery( '.js-products-productcount-container' ).css( 'visibility', 'hidden' );

            }
        },
        data: {
            post: function ( step, showLoading ) {
                if ( sika.shoefinder.debug === true ) {
                    console.log( 'post' );
                }
                var jForm = jQuery( '.js-sika-shoefinder-form' ),
                        serializedjForm = jForm.serializeArray(),
                        postStr = '';
                for ( var i = 0; i < serializedjForm.length; i++ ) {
                    if ( serializedjForm[ i ].value !== '' && serializedjForm[ i ].name.substring( 0, 4 ) !== 'data' ) {
                        if ( i > 0 ) {
                            postStr += '&';
                        }
                        postStr += serializedjForm[ i ].name + '=' + serializedjForm[ i ].value;
                    }
                }
                var jXhr = jQuery.ajax( {
                    url: e4.settings.ecom.filters.url,
                    type: 'POST',
                    data: postStr,
                    beforeSend: function () {
                        if ( showLoading === true ) {
                            sika.shoefinder.isLoaded = false;
                            sika.shoefinder.hasProducts = false;
                            jQuery( '.js-sika-shoefinder' ).addClass( 'page-transition-out' );
                            jQuery( '.js-sika-shoefinder-step' ).removeClass( 'animateIn animateOut' ).addClass( 'animateOut' );
                        }

                    }
                } );
                jQuery.when( jXhr ).done( function ( data ) {
                    //console.log(data,' got data ');
                    sika.shoefinder.store.facets.save( jForm.serializeArray() );

                    if ( showLoading === true ) {
                        if ( data.products.length > 0 ) {
                            sika.shoefinder.hasProducts = true;
                            sika.shoefinder.data.build.init( data, step, showLoading );
                        }
                        else {
                            sika.shoefinder.hasProducts = false;
                            jQuery( '.js-sika-shoefinder-step' ).addClass( 'animateIn' ).show();
                            sika.shoefinder.steps.displayer();
                            jQuery( '.js-sika-shoefinder-alert-modal' ).modal();
                        }
                    }
                    else {
                        if ( data.products.length > 0 ) {
                            sika.shoefinder.hasProducts = true;
                            sika.shoefinder.data.build.init( data, step, showLoading );
                        }
                        else {
                            sika.shoefinder.hasProducts = false;
                            sika.shoefinder.steps.displayer();
                            jQuery( '.js-sika-shoefinder-alert-modal' ).modal();
                        }

                    }
                } )
                      .fail( function ( error ) {
                          console.error( error );
                      } ).always( function ( jqXHR, textStatus ) {
                    if ( textStatus === 'timeout' ) {
                        console.error( 'timeout' );
                        sika.shoefinder.data.post( step, showLoading );
                    }
                } )

            },
            build: {
                init: function ( data, step, showLoading ) {
                    if ( sika.shoefinder.debug === true ) {
                        console.log( 'build start' );
                    }
                    sika.shoefinder.data.build.templates( data, step, showLoading );
                    sika.shoefinder.data.build.partials( step, showLoading );
                    if ( jQuery( '.js-sika-shoefinder' ).is( '.js-e-loading-overlay-override' ) === true ) {
                        //e4.pageLoading.manualOverride( '.js-sika-shoefinder' );
                    }

                },
                templates: function ( data, step, showLoading ) {
                    if ( sika.shoefinder.debug === true ) {
                        console.log( 'templating start' );
                    }
                    var stepObj = sika.shoefinder.localData.steps[ step ],
                            backgroundImage = stepObj.isStartpage === true ? stepObj.startPage[ 0 ].backgroundImage : stepObj.backgroundImage;

                    if ( step > 0 && ( sessionStorage.getItem( 'sika.shoefinder.stickImage' ) !== null && sessionStorage.getItem( 'sika.shoefinder.stickImage' ) !== '' ) ) {
                        backgroundImage = sessionStorage.getItem( 'sika.shoefinder.stickImage' );
                    }

                    for ( var i = 0; i < stepObj.options.length; i++ ) {
                        var option = stepObj.options[ i ];
                        if ( stepObj.hasNestedOptions === true ) {
                            for ( var n = 0; n < option.nestedOptions.length; n++ ) {
                                var nestedOption = option.nestedOptions[ n ];
                                for ( var x = 0; x < data.facets.length; x++ ) {
                                    var facet = data.facets[ x ];
                                    if ( nestedOption.inputName === facet.name ) {
                                        if ( facet.count === 0 ) {
                                            nestedOption.disabled = true;
                                        }
                                        else {
                                            if(nestedOption.inputName === 'Sizes') {
                                                var doesOptionValueExsistInFacet = facet.options.filter( function ( obj ) {
                                                    return nestedOption.value === obj.label;
                                                } ).length > 0;
                                                nestedOption.disabled = !doesOptionValueExsistInFacet;
                                            }
                                            for ( var y = 0; y < facet.options.length; y++ ) {
                                                var facetOption = facet.options[ y ];
                                                if ( nestedOption.value === facetOption.label ) {
                                                    if ( facetOption.count === 0 ) {
                                                        nestedOption.disabled = true;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            for ( var d = 0; d < data.facets.length; d++ ) {
                                var facet = data.facets[ d ];
                                if ( option.inputName === facet.name ) {
                                    if ( facet.count === 0 ) {
                                        option.disabled = true;
                                    }
                                    else {
                                        if(option.inputName === 'Sizes'){
                                            var doesOptionValueExsistInFacet = facet.options.filter(function(obj) {
                                                return option.value === obj.label;
                                            }).length > 0;
                                            option.disabled = !doesOptionValueExsistInFacet;
                                        }

                                        for ( var a = 0; a < facet.options.length; a++ ) {
                                            var facetOption = facet.options[ a ];
                                            if ( option.value === facetOption.label ) {
                                                if ( facetOption.count === 0 ) {
                                                    option.disabled = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if ( stepObj.hasNestedOptions === true && ( sika.shoefinder.globals.checkNestedStepOnPrev === true || ( stepObj.id === 4 && jQuery( '.js-sika-shoefinder-post-values[data-index="4"]' ).val() ) ) ) {
                        stepObj.showNextButton = true;
                        sika.shoefinder.globals.hasNextButton = true;
                    }
                    else {
                        stepObj.showNextButton = false;
                        sika.shoefinder.globals.hasNextButton = false;
                    }
                    if ( sika.shoefinder.debug === true ) {
                        console.log( stepObj );
                    }
                    jQuery( '.js-sika-shoefinder-step-container' ).html( e4.handlebars.tmpl.shoefinderSteps( stepObj ) );

                    jQuery( '<img/>' ).attr( 'src', backgroundImage ).on( 'load', function () {
                        jQuery( this ).remove();
                        jQuery( '.js-sika-shoefinder-step-background' ).hide();
                        sika.shoefinder.data.build.show( backgroundImage, showLoading );
                    } );
                    if ( sika.shoefinder.debug === true ) {
                        console.log( data );
                    }
                    if ( data !== null ) {

                        if ( stepObj.isProductpage === true ) {
                            e4.util.hash.set( 'productlist', 'true' );
                        }
                        else {
                            e4.util.hash.remove( 'productlist' );
                            e4.util.hash.remove( 'product' );
                        }
                        sika.shoefinder.productList.update( data );
                    }
                    sika.shoefinder.store.facets.load();
                },
                partials: function ( step, showLoading ) {
                    for ( var i = 0; i < sika.shoefinder.localData.navigation.length; i++ ) {
                        var navIndex = parseInt( sika.shoefinder.localData.navigation[ i ].index ),
                                stepIndex = parseInt( step );
                        sika.shoefinder.localData.navigation[ i ].classlist = '';
                        if ( navIndex === stepIndex ) {
                            sika.shoefinder.localData.navigation[ i ].classlist = 'active ';
                        }
                        if ( navIndex < stepIndex ) {
                            sika.shoefinder.localData.navigation[ i ].classlist = 'visited ';
                        }
                    }
                    jQuery( '.js-sika-shoefinder-navigation-container' ).html( e4.handlebars.partial.shoefinderNavigation( sika.shoefinder.localData ) );
                    jQuery( '.js-sika-shoefinder-feedback-container' ).html( e4.handlebars.partial.shoefinderFeedback( sika.shoefinder.localData ) );

                },
                show: function ( backgroundImageUrl, showLoading ) {
                    e4.scrollToAnchor.animate( 0, e4.nav.global.hide );
                    if ( sika.shoefinder.debug === true ) {
                        console.log( 'show start' );
                    }
                    if ( showLoading === true ) {
                        setTimeout( function () {
                            jQuery( '.js-sika-shoefinder-step-background' ).css( 'background-image', 'url(' + backgroundImageUrl + ')' ).show();
                            if ( jQuery( '.js-sika-shoefinder-step-nested' ).length > 1 ) {
                                jQuery( '.js-sika-shoefinder-step-nested' ).hide();
                                jQuery( '.js-sika-shoefinder-step-nested' ).each( function ( index ) {
                                    if ( index === 0 || jQuery( this ).find( '.js-sika-shoefinder-question-nested' ).is( ':checked' ) === true ) {
                                        jQuery( this ).show();
                                    }
                                } );
                            }
                            jQuery( '.js-sika-shoefinder' ).one( e4.settings.event.transitionend, function () {
                                jQuery( '.js-sika-shoefinder' ).removeClass( 'page-transition-in' );
                                sika.shoefinder.isLoaded = true;
                            } ).removeClass( 'page-transition-out' ).addClass( ' page-transition-in' );
                            if ( sika.shoefinder.debug === true ) {
                                console.log( 'build end' );
                            }
                        }, sika.shoefinder.options.timeout );
                    }
                    else {
                        jQuery( '.js-sika-shoefinder-step-background' ).css( 'background-image', 'url(' + backgroundImageUrl + ')' ).show();
                    }

                }
            },
            reset: function(doReload){
                if ( sika.favorites.cartData !== null ) {
                    sika.favorites.emptyCart( sika.favorites.cartData.cart.orderlines, false );
                }
                e4.util.hash.remove( 'question' );
                e4.util.hash.remove( 'productlist' );
                e4.util.hash.remove( 'product' );
                sika.shoefinder.steps.clear();

                if(doReload === true){
                    location.reload();
                }

            }
        }

    };
}() );

